import { createReducer } from "redux-act";
import { openDialog, closeDialog, showMessage, hideMessage, logIn } from "./actions";
import { combineReducers } from "redux";
import Typography from 'antd/lib/typography';
var defaultState = {
    isDialogOpen: false,
    Component: Typography
};
var defaultMessageState = {
    isMessageShown: false,
    messageType: '',
    messageCode: -1,
    messageText: '',
};
var dialogReducer = createReducer({}, defaultState).on(openDialog, function (state, payload) {
    return {
        isDialogOpen: true,
        Component: payload.Component
    };
}).on(closeDialog, function (state, payload) {
    return {
        isDialogOpen: false,
        Component: Typography
    };
});
var messageReducer = createReducer({}, defaultMessageState).on(showMessage, function (state, payload) {
    return {
        isMessageShown: true,
        messageType: payload.messageType,
        messageCode: payload.messageCode,
        messageText: payload.messageText,
    };
}).on(hideMessage, function (state, payload) {
    return {
        isMessageShown: false,
        messageType: "",
        messageCode: -1,
        messageText: "",
    };
});
var isLoggedInReducer = createReducer({}, false).on(logIn, function () { return true; });
var appReducer = combineReducers({
    dialog: dialogReducer,
    message: messageReducer,
    isLoggedIn: isLoggedInReducer
});
var AppReducer = ({
    app: appReducer
});
export default AppReducer;



//////////////////
// WEBPACK FOOTER
// ./src/app-ducks/index.ts
// module id = 602
// module chunks = 0